<template>
  <div id="car-list">
    <!-- Empty list -->
    <NoCarsCard v-if="cars.filtered.length == 0" />
    <div v-else class="car-wrapper" v-for="(car, index) in cars.filtered" :key="car.key">
      <Car
        :listing-details="car"
        :currentIndex="index"
        :expandedIndex="expandedCarIndex"
        @toggleView="handleToggleView"
        />
    </div>
  </div>
</template>

<script>
import Car from "@/components/Car.vue";
import NoCarsCard from "@/components/NoCarsCard.vue";
import { mapState } from "vuex";

export default {
  name: "CarList",
  props: {
    order: String,
  },
  components: {
    Car,
    NoCarsCard,
  },
  data() {
    return {
      expandedCarIndex: null,
      openedModalKey: null,
    };
  },
  computed: {
    ...mapState(["searchParameters", "cars"]),
    errorMessage() {
      return this.$store.state.errorMessage;
    },
  },
  methods: {
    handleToggleView(index) {
      if (this.expandedCarIndex === index) {
        // If the clicked car is already expanded, collapse it
        this.expandedCarIndex = null;
      } else {
        this.expandedCarIndex = index;
      }
    },
    // handleModalOpen() {
    //   this.$emit('modalOpen');
    // },
    // handleModalClose() {
    //   this.$emit('modalClose');
    // },
    handleModalOpen(payload) {
      this.openedModalKey = payload.key;
      alert('Payload Key',this.openedModalKey)
    },
    handleModalClose(payload) {
      if (this.openedModalKey === payload.key) {
        this.openedModalKey = null;
        alert('Payload Key',this.openedModalKey)
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

.car-wrapper {
  margin-bottom: 28px;
  width: min-content;
}

.warning-box {
  margin-bottom: $standard-padding;
  background-color: white;
  border-color: #ffae42;
  color: #ffae42;
  min-width: 150px;
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 3px;
  i {
    padding-right: 5px;
    vertical-align: middle;
    font-size: 24px;
  }
  box-shadow: 0 1px 3px rgba(#000, 0.12), 0 1px 2px rgba(#000, 0.24);
  &:hover {
    box-shadow: 0 3px 6px rgba(#000, 0.16), 0 3px 6px rgba(#000, 0.23);
  }
  .error-message {
    color: black;
  }
}
/* -- Mobile Styles -- */
@media (max-width: 1120px) {
  .car-wrapper {
    max-width: 400px;
    width: 100%;
  }
  #car-list {
    margin: 1.75em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
